import router from '../router';
import fetch from 'node-fetch';
import jwt from 'jsonwebtoken';

export function guardarTokenApi(tokenApi) {
	const sesion = jwt.decode(tokenApi);
	localStorage.setItem('tokenApi', tokenApi);
	localStorage.setItem('sesion', JSON.stringify(sesion));
}

export function eliminarTokenApi() {
	localStorage.removeItem('tokenApi');
}

export function obtenerTokenApi() {
	return localStorage.getItem('tokenApi');
}

export function obtenerSesion() {
	return JSON.parse(localStorage.getItem('sesion'));
}

export function eliminarSesion() {
	localStorage.removeItem('sesion');
}


export async function api(path, method='GET', data=null, auth=null) {
	const requestData = {
		method: method,
		headers: {}
	}

	if (auth) {
		requestData.headers['Authorization'] = auth;
	} else {
		const token = obtenerTokenApi();
		requestData.headers['Authorization'] = `Bearer ${token}`;
	}

	if ( data ) {
		requestData.body = JSON.stringify(data);
		requestData.headers['Content-Type'] = 'application/json';
	}

	let url;
	if (location.port == 8080) {
		// Si estamos usando el servidor de Vue (puerto 8080), fijar la URL de la API en su localización correcta
		url = `${location.protocol}//${location.hostname}:4136/api/v1${path}`;
	} else {
		// Si estamos usando la webapp estática, usar simplemente la URL relativa para la API
		url = `/api/v1${path}`;
	}

	let response;

	try {
		response = await fetch(url, requestData);
	} catch (error) {
		return {'error': 'Error desconocido'};
	}

	if (response.status == 401 && router.currentRoute.name != 'Login') {
		router.push('/acceso');
	}

	const responseData = await response.json();
	return responseData;
}

export function login(token) {
	guardarTokenApi(token);
	// TODO: go to the expected path
	// Maybe do this on the controller?
	router.push('/');
}

export function logout() {
	eliminarSesion();
	eliminarTokenApi();
	//router.push('/acceso');
}
